import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateParams, StateService } from '@uirouter/angular';
import { AddonRouteType, AddonStatus } from 'my-account/constants';
import { Subscription } from 'rxjs';
import { Cloudinary } from 'services/cloudinary';
import { XmStore, XmStoreUtil } from 'services/store';
import { Util } from 'services/util';
import { AccountSummary, SummaryLineWithPlan } from 'store/account-summary/models';
import { Addon, AddonCollections } from 'store/addons';
import { CmsCallFromUS } from 'store/cms/models';

@Component({
    selector: 'xm-call-from-us',
    templateUrl: './call-from-us.html',
    styleUrls: ['./call-from-us.scss'],
    standalone: false
})
export class XmCallFromUS implements OnInit, OnDestroy {
    public pageData: CmsCallFromUS;
    public mexCanImage: MediaImageOptions;
    public inUseIcon: MediaImageOptions;
    public callFromUSContent: CallFromUSContent;
    public mexCanData: Addon;
    public mexCanState: string;
    public isPendingRemoval: boolean;
    public showActiveIcon: boolean = true;
    public uiParams: StateParams;

    private lineByKey: SummaryLineWithPlan;
    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];
    private state: StateService;

    constructor(state: StateService, xmStore: XmStore) {
        Object.assign(this, { state, xmStore });
    }

    public ngOnInit(): void {
        this.uiParams = this.state.params;

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCallFromUS>(CmsCallFromUS), (result: CmsCallFromUS) => {
            this.pageData = result;
            this.mexCanImage = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.mexCanIcon)
            };
            this.inUseIcon = {
                mobile: Cloudinary.generateMediaFromCms(this.pageData.inUseIcon)
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AccountSummary>(AccountSummary), (accountSummary: AccountSummary) => {
            this.lineByKey = accountSummary.getLineSummaryWithPlanByKey(this.state.params.line_id);
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<AddonCollections>(AddonCollections, { filters: { lineId: this.state.params.line_id } }), (addons: AddonCollections) => {
            this.mexCanData = addons.addons.find((addon: Addon) => addon.isMexicoCanadaPass);
            if (this.mexCanData) {
                this.buildContent();
            } else {
                this.state.go('account.activity.details', { line_id: this.state.params.line_id });
            }
        }));
    }

    public buildContent(): void {
        switch (this.mexCanData.state) {
            case AddonStatus.ACTIVE:
                this.mexCanState = AddonStatus.ACTIVE;
                break;
            case AddonStatus.INACTIVE:
                this.mexCanState = AddonStatus.INACTIVE;
                this.showActiveIcon = false;
                break;
            case AddonStatus.PENDING_REMOVAL:
                this.isPendingRemoval = true;
                this.mexCanState = AddonStatus.PENDING_REMOVAL;
                break;
        }

        this.callFromUSContent = this.pageData.callFromUSContent.find((content: CallFromUSContent) => content.state === this.mexCanState);
        this.callFromUSContent.cardDescription = this.callFromUSContent.cardDescription.replace(/\[NICKNAME\]/g, this.lineByKey.line.displayName);
        this.callFromUSContent.activeUntilInfo = (this.isPendingRemoval &&  this.mexCanData.endDate) ? this.callFromUSContent.activeUntilInfo.replace('[DATE]', this.mexCanData.endDate) : '';
    }

    public launchCanMexFlow(): void {
        switch (this.mexCanState) {
            case AddonStatus.ACTIVE:
                this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'remove' });
                break;
            case AddonStatus.INACTIVE:
                this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'add' });
                break;
            case AddonStatus.PENDING_REMOVAL:
                this.state.go('account.activity.addon.review', { addon_type: AddonRouteType.MEX_CAN_PASS, intent: 'remove' });
                break;
        }
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
